import { Action, store } from 'types';
import { actions } from 'sharedConstants';

const initial: store.AccountShape = {
  user: null,
  loading: false,
};

export default (state: any = initial, action: Action) => {
  switch (action.type) {
    case actions.GET_CURRENT_USER_REQUEST: {
      return {
        user: null,
        loading: true,
      };
    }
    case actions.GET_CURRENT_USER_SUCCESS: {
      return {
        user: action.payload,
        loading: false,
      };
    }
    case actions.GET_CURRENT_USER_FAIL: {
      return {
        user: null,
        loading: false,
      };
    }
    case actions.SIGN_OUT: {
      return {
        user: null,
        loading: false,
      };
    }
    default: return state;
  }
};
